/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import GiftCardDetailsSection from "./GiftCardDetailsSection ";
import GiftCardRedemptionSection from "./GiftRedeemSection";
import BackSection from "./BackSections";
import ModalComponent from "./Modal";
// import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { onProductByProductIdSubmit } from "../../Store/Slices/productSlice";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import Loader from "../Loader/Loader";
// import PageError500 from "../PageError/PageError";
// import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { getProductList } from "../../Store/Slices/productSlice";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { onGetClientCapping } from "../../Store/Slices/clientCappingSlice";
import { GetProdBudSumData, LoginReducerData } from "../Utility/Utility";
import { decryptURLParam } from "../../Common/Axios/encrypt";
import { getclientConfigDataAsync } from "../../Store/Slices/clientConfigDataSlice";

const GiftCardOptimized = () => {
  const dispatch = useDispatch();
  // const productData = useSelector((state) => state?.productDataReducer)
  const [enhancedProductReducer, setEnhancedProductReducer] = useState(null);
  // Conditionally decrypt the productId from URL based on environment setting
  const encryptedProductId = window.location.href.split("=")[1];
  const productId = encryptedProductId
    ? (process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false'
      ? encryptedProductId
      : decryptURLParam(encryptedProductId))
    : null;
  const [isLoading, setIsLoading] = useState(true);
  const supplierCapping = useSelector(
    (state) => state?.clientCappingSliceReducer?.clientCappingData
  );
  const loginReducerData = LoginReducerData();
  useEffect(() => {
    setIsLoading(true);
    if (supplierCapping?.length === 0 || supplierCapping === undefined) {
      dispatch(onGetClientCapping(parseInt(loginReducerData?.clientId)));
    }
    const payload = {
      productId: productId,
      isFeatured: false,
      pageNumber: 1,
      pageSize: 100,
    };
    dispatch(getProductList(payload))
      .then((res) => {
        if (res?.payload?.response?.products) {
          let product = res?.payload.response.products.find(
            (prod) => prod.id === parseInt(productId)
          );
          setProduct(product);

          setEnhancedProductReducer({
            ...product,
            priceDenomination: product?.priceDenominations,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [productId]);
  // const translation = getTranslationData();
  // const location = useLocation();
  // const dispatch = useDispatch();
  // const productData = location.state?.productData?.item;

  // const [enhancedProductReducer, setEnhancedProductReducer] = useState(null);

  // const productReducer = useSelector(
  //   (state) => state.productReducer?.productByProductId
  // );
  // const productLoading = useSelector((state) => state.productReducer);
  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );
  // const url = window.location.href.split("=")[1];
  // useEffect(() => {
  //     dispatch(onGetClientProductMappingbyId(sessionStorage.getItem("clientCode")));
  // }, []);

  // useEffect(() => {
  //   if (url) {
  //     dispatch(onProductByProductIdSubmit(url));
  //   }
  // }, [url, productData?.id]);

  // useEffect(() => {
  //   if (productReducer && productDiscount) {
  //     const discount = productDiscount.find(
  //       (discountItem) => discountItem.productId === productReducer[0]?.id
  //     );
  //     const customerDiscount = discount?.customerDiscount;
  //     setEnhancedProductReducer({
  //       ...productReducer[0],
  //       customerDiscount,
  //       priceDenomination: discount?.priceDenomination,
  //     });
  //   }
  // }, [productReducer, productDiscount]);

  // useEffect(() => {
  //   if (productData) {
  //     setEnhancedProductReducer({
  //       ...productData?.data,
  //       priceDenomination: productData?.data?.priceDenominations,
  //   })
  // }
  // }, [productData]);
  const hasValidDenomination = (denom) => {
    return denom && denom !== "0" && denom?.trim() !== "";
  };
  const prodSumData = GetProdBudSumData();

  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const clientInfo = useSelector((state) => state.clientDataReducer);

  useEffect(() => {
    if (!clientInfo)
      return;

    const cardSectionConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete")
    if (cardSectionConfig && cardSectionConfig?.configValue === 1) {
      (async () => {
        if (cardListData?.clientConfigData?.cards?.length > 0) {
          return;
        }
        else {
          await dispatch(getclientConfigDataAsync("widgetdata")).then((res) => {
          }).catch((err) => {
            console.error("Error fetching card list:", err);
          });
        }
      })();
    }
  }, [clientInfo])



  return (
    <>
      <ScrollToTop />
      {isLoading || prodSumData?.isLoading ? (
        <Loader />
      ) : (
        <div className="bg">
          {
            hasValidDenomination(enhancedProductReducer?.priceDenominations) ? (
              <>
                <BackSection />
                <GiftCardDetailsSection
                  productReducer={enhancedProductReducer}
                />
                <GiftCardRedemptionSection
                  productReducer={enhancedProductReducer}
                />
                {/* <FeaturedGiftCardsSection productList={featureProducts} /> */}
                <ModalComponent productReducer={enhancedProductReducer} />
              </>
            ) : null
            // (
            //   <PageError500
            //     pageError={{
            //       StatusCode: "500",
            //       ErrorName: "Product Not Available",
            //       ErrorDesription:
            //         "The requested product is currently unavailable. Please try again later.",
            //       url: "/",
            //       buttonText: translation?.backToHome,
            //     }}
            //   />
            // )
          }
        </div>
      )}
    </>
  );
};

export default GiftCardOptimized;
